import api from "@/plugins/axios";
import Size from "@/models/size";
import { Meta } from "@/models/general";

const SizesAPI = {
  async newSize(payload: Size): Promise<Size | undefined> {
    return api.post("/sizes", payload);
  },
  async updateSize(payload: Size): Promise<Size | undefined> {
    return api.put(`/sizes/${payload.id}`, payload);
  },
  async getSize(id: string): Promise<Size> {
    return api.get(`/sizes/${id}`);
  },
  async getSizes(
    page: number,
    pageSize: number
  ): Promise<{ data: Size[]; meta: Meta }> {
    return api.get("/sizes", {
      params: { page: { number: page, size: pageSize } },
    });
  },
  async deleteSize(id: string): Promise<void> {
    return api.delete(`/sizes/${id}`);
  },
};

export default SizesAPI;
